import { Grid } from "@mui/material/";
import CircularProgress from "@mui/material/CircularProgress";
import masterlogo from "../assets/images/icons/logo.svg";
const Spinner = () => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      className="proGressP"
      alignItems="center"
    >
      <img
        src="https://storage.mastertrust.co.in/websites/sp-rekyc-logo.svg"
        alt="logo"
        width="200px"
      />
      <CircularProgress />
    </Grid>
  );
};

export default Spinner;
